export default __webpack_public_path__ + "static/koala-6bf275999c6756810d4333b8904810d3214ca0d5f3ff6599358492d027bd6fdf.svg";